export const SUPPORT_LINK = 'https://t.me/MC_Platform_Support';
